import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEETS_WORK_CALENDAR } from "src/api-setup/api-endpoints";
import {
  setWorkCalendarData,
  setWorkCalendarLoading,
} from "src/redux/actions/work-calendar-action";

export const getWorkCalendar = async (
  cookiesData,
  dispatch,
  params = {},
  scope = {}
) => {
  if (!cookiesData) return null;

  try {
    dispatch(setWorkCalendarLoading(true));

    const {
      providerId,
      startDate,
      endDate,
      groupBy = "days",
      contractTypeMstrKey = null,
      contractMstrKey = null,
      deviceLocalTz = "Asia/Kolkata",
      filter = null,
    } = params;

    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_contract_type_mstr_key: contractTypeMstrKey,
      in_contract_mstr_key: contractMstrKey,
      in_group_by: groupBy,
      in_filter: filter,
      in_sort_number: 1,
      in_sort_order: "ASC",
      in_start_date: startDate,
      in_end_date: endDate,
      in_device_local_tz: deviceLocalTz,
      ...scope,
    };

    const response = await POSTAPI(
      false,
      GET_TIMESHEETS_WORK_CALENDAR,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );
    if (response?.data?.out_parameters) {
      const { out_ret_code } = response.data.out_parameters;

      if (out_ret_code === 0) {
        const rowResult = response.data?.row_result;
        dispatch(setWorkCalendarData(rowResult));
        dispatch(setWorkCalendarLoading(false));
        return rowResult;
      }
    }

    dispatch(setWorkCalendarLoading(false));
    return null;
  } catch (error) {
    console.error("Error fetching work calendar:", error);
    dispatch(setWorkCalendarLoading(false));
    return null;
  }
};
